<template>
  <v-container>
    <v-card v-if="showcase">
      <v-toolbar flat color="orange lighten-2">{{ title }} </v-toolbar>
      <v-tabs center-active>
        <v-tab>Info</v-tab>
        <v-tab>Environments</v-tab>
        <v-tab>Operations</v-tab>
        <v-tab-item class="pa-2">
          <ShowcaseInformation
            :key="showcase.showcaseId"
            :showcase="showcase"
          ></ShowcaseInformation>
        </v-tab-item>
        <v-tab-item class="pa-2">
          <ShowcaseEnvironmentTable
            :key="showcase.showcaseId"
            :showcase="showcase"
          ></ShowcaseEnvironmentTable>
        </v-tab-item>
        <v-tab-item class="pa-2">
          <ShowcaseOperations
            :key="showcase.showcaseId"
            :showcase="showcase"
          ></ShowcaseOperations>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import ShowcaseEnvironmentTable from './environment/ShowcaseEnvironmentTable'
import ShowcaseInformation from './ShowcaseInformation'
import ShowcaseOperations from './operation/ShowcaseOperations'
export default {
  name: 'ShowcaseDetails',
  components: {
    ShowcaseInformation,
    ShowcaseEnvironmentTable,
    ShowcaseOperations
  },
  props: ['showcase'],
  data: () => ({}),
  computed: {
    title: function() {
      if (this.showcase) {
        return this.showcase.name + ' (' + this.showcase.showcaseId + ')'
      }
      return ''
    }
  }
}
</script>

<style scoped></style>
